import { ColorEnum } from '@/constants/color'
import { Channel, DeliveryTypeCategory } from '@/features/orders/constants/app'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'

interface DeliveryTypeCategoryAndChannelProps {
    deliveryTypeCategory: DeliveryTypeCategory
    channel: Channel
}

const DeliveryTypeCategoryAndChannel: FC<DeliveryTypeCategoryAndChannelProps> = ({
    deliveryTypeCategory,
    channel,
}) => {
    const { t } = useTranslation()

    return (
        <Typography.Heading
            variant="h3"
            numberOfLines={1}
            style={styles.deliveryTypeCategoryAndChannel}
        >
            {t(`order.deliveryTypeCategory.${deliveryTypeCategory}`, deliveryTypeCategory)}
            {' | '}
            {t(`order.channel.${channel}`, channel)}
        </Typography.Heading>
    )
}

const styles = StyleSheet.create({
    deliveryTypeCategoryAndChannel: {
        flex: 1,
        color: ColorEnum.GRAY_900,
        lineHeight: 26,
    },
    code: {
        backgroundColor: ColorEnum.YELLOW_400,
        borderRadius: 4,
        height: 16,
        minWidth: 16,
        textAlign: 'center',
        marginStart: 8,
        fontSize: 12,
    },
})

export default DeliveryTypeCategoryAndChannel
